// Angular
import { Component } from '@angular/core';

@Component({
	standalone: false,
selector: 'kt-order-edit',
	templateUrl: './order-edit.component.html'
})
export class OrderEditComponent { }
